import { Button } from '@localagent/ui/components/button';

export function CreditPackCard({
  onPurchase,
  isPurchasing,
}: {
  onPurchase: () => void;
  isPurchasing: boolean;
}) {
  return (
    <div className="rounded-lg bg-card p-4 space-y-3">
      <h3 className="text-sm font-medium text-muted-foreground">Credit Pack</h3>
      <div className="flex items-center justify-between">
        <div>
          <p className="font-medium">5,000 Credits</p>
          <p className="text-sm text-muted-foreground">One-time purchase, no expiration</p>
        </div>
        <div className="flex items-center gap-3">
          <span className="text-lg font-semibold">$15</span>
          <Button size="sm" onClick={onPurchase} disabled={isPurchasing}>
            {isPurchasing ? 'Purchasing...' : 'Buy Credits'}
          </Button>
        </div>
      </div>
    </div>
  );
}
